export const config = {
  serverURL: process.env.REACT_APP_SERVER_URL!,
  API: process.env.REACT_APP_API_URL!,
  ws: process.env.REACT_APP_WS_URL!,
  imageProxy: process.env.REACT_APP_IMAGE_PROXY!,
  editorKey: process.env.REACT_APP_EDITOR_KEY!,
  mapKey: process.env.REACT_APP_MAP_KEY!,
} as const;
